import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom';
import Functions from './function';
import Logo from '../../../images/public/websitefooter.png'

const Index = () => {
    const [searchParams] = useSearchParams();
    const [formData,setFormData] = useState(null);
    useEffect(()=>{
        Functions.Get(searchParams.get('doctor'),searchParams.get('from'),searchParams.get('to'),setFormData);
    },[])
  return (
    <>
        <div style={{width:"200px",margin:"20px auto"}}>
            <img src={Logo} style={{width:"100%"}}/>
        </div>
      {formData &&
      <>
        <div style={{display:"flex",justifyContent:"space-between"}}>
            <h3 style={{fontWeight:"500",fontSize:"18px"}}>{formData.doctor}</h3>
            <p>From: {searchParams.get('from')} To: {searchParams.get('to')}</p>
        </div>
        <div style={{backgroundColor:"#2F1C60",height:"5px",margin:"10px 0px"}}></div>
        <div style={{display:"flex",border:"1px solid black"}}>
            <div style={{width:"10%", borderRight:"1px solid black", padding:"10px"}}>
                <h3 style={{fontSize:"16px",fontWeight:"500"}}>#</h3>
            </div>
            <div style={{width:"60%", borderRight:"1px solid black", padding:"10px"}}>
                <h3 style={{fontSize:"16px",fontWeight:"500"}}>Description</h3>
            </div>
            <div style={{width:"30%", padding:"10px"}}>
                <h3 style={{fontSize:"16px",fontWeight:"500",textAlign:"right"}}>Amount</h3>
            </div>
        </div>
        <div style={{display:"flex",borderBottom:"1px solid black",borderLeft:"1px solid black",borderRight:"1px solid black"}}>
            <div style={{width:"10%", borderRight:"1px solid black", padding:"10px"}}>
                <h3 style={{fontSize:"16px",fontWeight:"500"}}></h3>
            </div>
            <div style={{width:"60%", borderRight:"1px solid black", padding:"10px"}}>
                <h3 style={{fontSize:"16px",fontWeight:"500"}}>Opening Balance</h3>
            </div>
            <div style={{width:"30%", padding:"10px"}}>
                <h3 style={{fontSize:"16px",fontWeight:"500",textAlign:"right"}}>{formData.openingbalance}</h3>
            </div>
        </div>
        {formData.lineitems.map((item,index)=>{
            return(
                <div key={index} style={{display:"flex",borderBottom:"1px solid black",borderLeft:"1px solid black",borderRight:"1px solid black"}}>
                    <div style={{width:"10%", borderRight:"1px solid black", padding:"10px"}}>
                        <h3 style={{fontSize:"16px",fontWeight:"500"}}>{item.id}</h3>
                    </div>
                    <div style={{width:"60%", borderRight:"1px solid black", padding:"10px"}}>
                        <h3 style={{fontSize:"16px",fontWeight:"500"}}>{item.description}</h3>
                    </div>
                    <div style={{width:"30%", padding:"10px"}}>
                        <h3 style={{fontSize:"16px",fontWeight:"500",textAlign:"right"}}>{item.amount}</h3>
                    </div>
                </div>
            )
        })}
        <div style={{display:"flex",borderBottom:"1px solid black",borderLeft:"1px solid black",borderRight:"1px solid black"}}>
            <div style={{width:"10%", borderRight:"1px solid black", padding:"10px"}}>
                <h3 style={{fontSize:"16px",fontWeight:"500"}}></h3>
            </div>
            <div style={{width:"60%", borderRight:"1px solid black", padding:"10px"}}>
                <h3 style={{fontSize:"16px",fontWeight:"500"}}>Closing Balance</h3>
            </div>
            <div style={{width:"30%", padding:"10px"}}>
                <h3 style={{fontSize:"16px",fontWeight:"500",textAlign:"right"}}>{formData.closingbalance}</h3>
            </div>
        </div>
      </>
      }
    </>
  )
}

export default Index
